import * as z from "zod/v4";

export const getSuggestedProductsForLiquidation = {
  name: "getSuggestedProductsForLiquidation" as const,
  input: z.object({
    limit: z.number().min(1).max(100).default(20),
    cursor: z.string().optional(),
    filters: z
      .object({
        minInventory: z.number().min(1).default(10),
        maxDaysSinceLastSale: z.number().min(1).default(60),
        priceDiscountThreshold: z.number().min(0).max(1).default(0.2),
      })
      .optional(),
  }),
  output: z.object({
    suggestions: z.array(
      z.object({
        productId: z.string(),
        variantId: z.string(),
        productName: z.string(),
        sku: z.string(),
        unitsAvailable: z.number(),
        variantsCount: z.number(),
        price: z.number(), // in cents
        msrpPrice: z.number(), // in cents
        discountPercentage: z.number().default(0),
        potentialProfit: z.number(), // in cents
        imageUrl: z.string().optional(),
        recommendedChannels: z.array(z.string()),
        liquidationScore: z.number().default(0), // 0-100 priority score
      }),
    ),
    nextCursor: z.string().optional(),
    totalCount: z.number(),
  }),
};
